<template>
  <div>
    <success-fade-alert ref="alertSuccess" :msg="alert.success" />
    <fade-alert-danger ref="alertDanger" :msg="alert.error" />

    <!-- Marca -->
    <b-form-group :label="$t('geral.brand') + ':'" label-for="input-brand">
      <b-input-group>
        <brand-vehicle-dropdown
          ref="brandVehicleDropdown"
          :brandVehicleId.sync="compBrandVehicleId"
        />

        <b-input-group-append>
          <b-button v-b-modal.modalBrand>
            <i class="tim-icons icon-simple-add" style="text-align: center" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-modal
      ref="modalBrand"
      id="modalBrand"
      title="Cadastro: Marca de veículo"
      :ok-title="$t('geral.save')"
      :cancel-title="$t('geral.cancel')"
    >
      <div>
        <b-col>
          <brand-vehicle :model="modelBrand" :modelstate="modelstate" />
        </b-col>

        <br />
      </div>

      <template #modal-footer="{}">
        <div style="text-align: right; width: 100%">
          <b-button variant="green" @click="saveBrand" style="margin-left: 5px">
            {{ $t("geral.confirm") }}
          </b-button>

          <b-button class="ml-2" variant="danger" @click="cancelModal">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  components: {
    "brand-vehicle-dropdown": () =>
      import("@/components_rms/System/BrandVehicle/BrandVehicleDropdown.vue"),
    "brand-vehicle": () =>
      import("@/components_rms/System/BrandVehicle/BrandVehicle.vue"),
    "success-fade-alert": () => import("@/components/SuccessFadeAlert.vue"),
    "fade-alert-danger": () => import("@/components/FadeAlertDanger.vue"),
  },
  props: {
    brandVehicleId: Number,
  },
  data() {
    return {
      alert: {
        error: "Erro ao criar registro: ",
        success: "Registro criado com sucesso",
      },
      modelstate: {},
      modelBrand: {
        name: "",
      },
      showErrorAlert: false,
    };
  },
  computed: {
    compBrandVehicleId: {
      get: function () {
        return this.brandVehicleId;
      },
      set: function (value) {
        this.$emit("update:brandVehicleId", value);
      },
    },
  },
  methods: {
    saveBrand() {
      this.modelstate = {};

      let obj = {
        name: this.modelBrand.name,
      };
      this.$apiScheduler
        .post("/brand/create/", obj)
        .then((response) => {
          this.$refs.brandVehicleDropdown.getListbrand();
          this.$emit("update:brandVehicleId", parseInt(response.data.id));
          this.$refs.modalBrand.hide();
          this.clearFields();
          this.$emit("saveBrand", response.data);
        })
        .catch((error) => {
          if (error.response.data == null) {
            this.modelstate = [];
            this.alert.error = error.response.title;
            this.showToastError();
            return;
          }
          if (error.response.data.errors != null) {
            this.modelstate = error.response.data.errors;
            this.alert.error = error.response.data.title;
            this.showToastError();
            return;
          }
          if (error.response.data.errorMessage) {
            this.modelstate = [];
            this.alert.error = error.response.data.errorMessage;
            this.showToastError();
            return;
          }
        });
    },
    cancelModal() {
      this.$refs.modalBrand.hide();
    },
    clearFields() {
      this.modelBrand = {
        name: "",
      };
    },
    showToastError(append = false) {
      this.$bvToast.toast(this.alert.error, {
        autoHideDelay: 5000,
        toaster: "b-toaster-top-full",
        variant: "danger",
        appendToast: append,
      });
    },
  },
};
</script>
